// extracted by mini-css-extract-plugin
export var chip = "_5b-9";
export var chipLabel = "_5b-a";
export var close = "_5b-7";
export var closeIcon = "_5b-8";
export var error = "_5b-6";
export var infoTooltip = "_5b-2";
export var innerContainer = "_5b-1";
export var input = "_5b-b";
export var medium = "_5b-5";
export var outerContainer = "_5b-0";
export var small = "_5b-4";
export var xSmall = "_5b-3";